import { stats } from "@/mocks/gua";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-900">
      <img
        src="https://readdy.ai/api/search-image?query=warm%20editorial%20magazine%20background%20of%20concentric%20radial%20ripple%20rings%20spreading%20from%20a%20glowing%20center%20hotspot%2C%20vintage%20newsroom%20textures%20with%20floating%20newspaper%20clippings%2C%20deep%20warm%20cream%20and%20tomato%20red%20and%20golden%20amber%20palette%2C%20abstract%20modern%20illustration%2C%20soft%20atmospheric%20lighting&width=1600&height=900&seq=hero-bg-gua&orientation=landscape"
        alt="吃瓜中心以热点事件为圆心的辐射扩散背景图"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/80 via-background-900/60 to-background-900"></div>

      <div className="relative mx-auto flex min-h-[620px] w-full max-w-[1200px] flex-col items-center justify-center px-4 py-28 text-center md:min-h-[700px] md:px-6 md:py-32">
        <p className="mb-5 inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-accent-400/10 px-4 py-1.5 text-xs font-medium tracking-wide text-accent-200">
          <i className="ri-radar-line"></i>
          全网热点，以事件为圆心
        </p>

        <h1 className="max-w-3xl font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
          吃瓜中心<span className="text-accent-300">点</span>，辐射全网热点周边
        </h1>

        <p className="mt-5 max-w-2xl text-sm leading-7 text-background-200 md:text-base">
          我们以热门事件为圆心，向外扩散挖掘关联人物与背景故事。从中心瓜到周边衍生瓜，
          这里提供完整的<strong className="text-accent-200">瓜田地图</strong>与
          <strong className="text-accent-200">扩散路径追踪</strong>，
          帮你看到事件背后的更多联系，吃瓜吃得更透彻。
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#map"
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-400"
          >
            打开瓜田地图
          </a>
          <a
            href="#mechanics"
            className="whitespace-nowrap rounded-md border border-background-300/50 bg-background-50/5 px-6 py-3 text-sm font-medium text-background-100 backdrop-blur transition-colors hover:bg-background-50/10"
          >
            看看怎么追瓜
          </a>
        </div>

        <div className="mt-12 grid w-full max-w-4xl grid-cols-2 gap-px overflow-hidden rounded-xl border border-background-300/30 bg-background-300/20 md:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="flex flex-col items-center gap-1 bg-background-900/50 px-4 py-5">
              <i className={`${s.icon} text-lg text-accent-300`}></i>
              <span className="font-heading text-xl font-bold text-background-50 md:text-2xl">{s.value}</span>
              <span className="text-xs text-background-300">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}